import {
  concatStyleSets,
  IStyle,
  mergeStyles,
} from "@fluentui/react/lib/Styling";
import { memoizeFunction } from "@fluentui/react/lib/Utilities";

export interface AppShyComponentClassNames {
  container?: string;
}

export interface AppShyComponentStyles {
  container?: IStyle;
  expanded?: IStyle;
  collapsed?: IStyle;
}

export const ShyComponentAnimationDuration = 400;
export const ShyComponentAnimationFunction = "cubic-bezier(0.8, 0, 0.2, 1)";

const getShyComponentStyles = memoizeFunction(
  (customStyles?: AppShyComponentStyles): AppShyComponentStyles => {
    const defaultStyles: AppShyComponentStyles = {
      container: {
        transition: `all ${ShyComponentAnimationDuration}ms ${ShyComponentAnimationFunction}`,
      },
      expanded: {
        opacity: 1,
      },
      collapsed: {
        opacity: 0,
      },
    };
    return concatStyleSets(defaultStyles, customStyles);
  }
);

export const getShyComponentClassNames = memoizeFunction(
  (
    isVisible: boolean,
    customStyles?: AppShyComponentStyles
  ): AppShyComponentClassNames => {
    const styles = getShyComponentStyles(customStyles);
    return {
      container: mergeStyles(
        styles.container,
        isVisible ? styles.expanded : styles.collapsed
      ),
    };
  }
);
